import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ScheduleTypeCellParamTemplateDetailsComponent from './ScheduleTypeCellParamTemplateDetailsComponent';
import Settings from '@mui/icons-material/Settings';
import { Card } from '@totalsoft/rocket-ui';

export const ScheduleTypeCellParamTemplateDetailsContainer = ({
  lens,
  columns,
  loading,
  saving,
  onResetDetailValues,
  canWrite
}) => {
  const [t] = useTranslation();

  return (
    <Card
      id={'scheduleTypeCellParamTemplateSeasonalSettingsCard'}
      icon={Settings}
      title={t('ScheduleTypeCellParamTemplate.Details.SeasonalSettings')}
    >
      {!loading && (
        <ScheduleTypeCellParamTemplateDetailsComponent
          lens={lens}
          columns={columns}
          saving={saving}
          onResetDetailValues={onResetDetailValues}
          readOnly={!canWrite}
        />
      )}
    </Card>
  );
};

ScheduleTypeCellParamTemplateDetailsContainer.propTypes = {
  lens: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  onResetDetailValues: PropTypes.func.isRequired,
  canWrite: PropTypes.bool.isRequired
};

export default ScheduleTypeCellParamTemplateDetailsContainer;
